<template>
  <mcs-btn
    v-if="enablePrint"
    icon
    small
    :class="[cart_count > 0 ? 'mr-5' : 'mr-3']"
    color="black"
    :disabled="disabled"
    @click="click"
  >
    <v-badge
      :value="cart_count > 0"
      color="primary"
      :content="cart_count"
    >
      <v-icon
        size="18"
        class="thick"
      >
        mdi-cart-outline
      </v-icon>
    </v-badge>
  </mcs-btn>
</template>

<script>
import { mapGetters } from 'vuex';
import { DRAWERS, PRINT_CHECKOUT_SCREENS } from '../../utils/constants';

export default {
  name: 'CartButton',

  props: { disableLoadData: { type: Boolean, default: false } },

  data() {
    return {};
  },

  computed: {
    disabled() {
      return false;
    },

    ...mapGetters({
      cart_count: 'printcart/cart_count',
      enablePrint: 'user/enablePrint'
    })
  },

  mounted() {
    // When disableLoadData is true the badge still populates if a parent loads
    // the full cart (SET_CART derives cart_count) or via the cross-app event listener.
    if (!this.disableLoadData) {
      this.$store.dispatch('printcart/getCartCount');
    }
  },

  methods: {
    click() {
      this.$store.dispatch('drawers/open', {
        drawerId: DRAWERS.PRINT_CHECKOUT,
        data: { screen: PRINT_CHECKOUT_SCREENS.CART }
      });
    }
  }
};
</script>

<style></style>
